<section class="migration-card" *ngIf="ownerId">
  <div class="migration-info">
    <div class="migration-icon">
      <i class="far fa-calendar-check"></i>
    </div>

    <div>
      <h3>Old Availability Migration</h3>

      <p>
        Convert old availability records for this
        {{ ownerType }} into the new weekly schedule.
      </p>

      <div class="migration-date-note">
        Only today and future records will be migrated.
        Past records will be ignored.
      </div>
    </div>
  </div>

  <div class="migration-result" *ngIf="result">
    <div>
      <span>Old records</span>
      <strong>{{ result.legacyRows }}</strong>
    </div>

    <div>
      <span>Weekly rules</span>
      <strong>{{ result.weeklyRows }}</strong>
    </div>

    <div>
      <span>Special dates</span>
      <strong>{{ result.overrideRows }}</strong>
    </div>

    <div>
      <span>Invalid records</span>
      <strong>{{ result.invalidLegacyRows }}</strong>
    </div>
  </div>

  <div
    class="migration-message"
    *ngIf="result?.reason"
  >
    {{ result.reason }}
  </div>

  <div
    class="migration-message error"
    *ngIf="errorMessage"
  >
    {{ errorMessage }}
  </div>

  <div class="migration-actions">
    <button
      type="button"
      class="migration-btn preview-btn"
      [disabled]="loading || migrating"
      (click)="previewMigration()"
    >
      <i class="far fa-search"></i>

      {{
        loading
          ? 'Checking...'
          : 'Check Old Availability'
      }}
    </button>

    <button
      type="button"
      class="migration-btn migrate-btn"
      *ngIf="previewCompleted"
      [disabled]="migrating"
      (click)="startMigration()"
    >
      <i class="far fa-exchange"></i>

      {{
        migrating
          ? 'Migrating...'
          : 'Migrate Now'
      }}
    </button>

    <span
      class="migration-completed"
      *ngIf="completed && result?.status === 'migrated'"
    >
      <i class="far fa-check-circle"></i>
      Migration completed
    </span>
  </div>
</section>